/**
 * Agent badges — pure data, imported by every panel that renders a chat bubble.
 * Kept separate from any component code so the palette can be extended without
 * pulling in JSX.
 */
export const AGENT_BADGES = {
  architect:   { label: 'Architect',   icon: '🏛️', color: 'text-purple-300 bg-purple-950/50 border-purple-800' },
  designer:    { label: 'Designer',    icon: '🎨', color: 'text-pink-300   bg-pink-950/50   border-pink-800' },
  developer:   { label: 'Developer',   icon: '💻', color: 'text-emerald-300 bg-emerald-950/50 border-emerald-800' },
  integration: { label: 'Integration', icon: '🔌', color: 'text-amber-300  bg-amber-950/50  border-amber-800' },
  qa:          { label: 'QA',          icon: '🧪', color: 'text-sky-300    bg-sky-950/50    border-sky-800' },
};
